export interface Props {
  className?: string;
}

export function PreloaderGalaxyIcon({className}: Props): JSX.Element {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M93.3643 139.557C77.9882 134.992 60.3444 118.13 61.3373 97.4013C61.6244 91.3914 63.2208 86.3114 66.0743 82.2651L72.9367 86.6017C68.6556 91.1078 67.6281 100.318 70.4347 107.943C74.4443 118.838 82.1451 125.521 91.455 130.362C92.8423 131.092 94.3146 131.615 95.6749 132.388C97.4432 133.391 98.1699 135.092 97.4688 137.149C96.7833 139.145 95.3219 140.135 93.3643 139.557Z"
        fill="url(#paint0_linear_12837_150142)"
      />
      <path
        d="M105.968 60.4501C121.126 63.8178 140.916 81.7751 139.718 102.298C139.457 106.77 138.373 110.788 136.492 114.266L129.673 110.657C133.465 103.45 132.834 96.0962 129.372 88.9609C124.702 79.3173 116.989 73.5573 108.023 69.574C106.593 68.9471 105.061 68.5585 103.746 67.7226C102.147 66.7071 101.202 65.0319 101.858 62.9181C102.507 60.8249 104.082 60.0272 105.968 60.4501Z"
        fill="url(#paint1_linear_12837_150142)"
      />
      <path
        d="M129.674 110.657C128.82 112.274 127.693 114.131 125.629 113.19C123.201 112.085 124.484 109.895 125.009 108.313C127.679 100.165 125.889 92.7262 121.109 86.3595C111.226 73.1686 98.0799 69.0714 83.4125 71.9646C75.3477 73.5561 69.4129 77.2393 65.7324 82.7654L72.9375 86.602C74.129 85.3513 75.4731 83.4476 77.3169 84.7961C79.3612 86.2802 77.824 88.1479 77.1527 89.7915C72.974 100.056 74.8362 109.565 82.3118 117.277C90.9041 126.131 101.174 129.026 109.788 128.764C123.551 127.737 132.767 122.106 137.04 113.19L129.674 110.657Z"
        fill="#3C19C3"
      />
      <path
        d="M117.998 91.0637C121.283 96.3747 121.607 102.511 118.947 108.688C116.741 113.751 120.83 117.456 125.591 115.333C129.215 113.717 130.902 108.482 131.497 106.096C131.651 105.479 132.318 105.115 132.909 105.351L133.393 105.545C133.826 105.718 134.081 106.164 133.982 106.62C133.49 108.89 131.695 115.535 127.015 118.655C121.319 122.452 114.611 124.825 105.658 124.825C98.9099 124.422 89.9145 120.483 83.8262 112.96C78.5298 106.407 78.7325 98.3693 82.7209 90.6453C83.3613 89.4085 84.6861 86.5456 82.9794 83.9673C81.6655 81.9823 79.5544 82.058 76.7067 83.0602C74.0737 83.9869 71.0324 87.6441 69.4788 90.4076C69.2623 90.7928 68.8314 91.0115 68.3961 90.9353L67.9885 90.8639C67.3517 90.7524 66.9863 90.0748 67.2731 89.4954C69.3737 85.2518 72.7084 81.481 75.7575 79.738C79.0795 77.8389 82.9808 75.9414 91.8944 75.4668C100.808 74.9922 111.206 80.0615 117.998 91.0637Z"
        fill="#4365D0"
      />
      <g filter="url(#filter0_d_12837_150142)">
        <path
          d="M110.996 88.0753C116.544 93.6239 118.005 101.086 113.984 109.125C110.692 115.709 114.233 116.312 110.996 119.086C107.759 121.861 93.9224 119.086 87.4217 111.586C80.921 104.086 83.7983 94.549 88.4214 88.075C91.6578 83.5428 88.8011 82.0635 92.5001 79.7524C96.1991 77.4412 105.448 82.5268 110.996 88.0753Z"
          fill="url(#paint2_radial_12837_150142)"
        />
      </g>
      <circle cx="100" cy="100" r="10" transform="rotate(-90 100 100)" fill="#BE2DFF" />
      <g filter="url(#filter1_d_12837_150142)">
        <circle cx="100" cy="100" r="7" transform="rotate(-90 100 100)" fill="url(#paint3_radial_12837_150142)" />
      </g>
      <defs>
        <filter
          id="filter0_d_12837_150142"
          x="25.6279"
          y="21.1809"
          width="148.642"
          height="156.959"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="29" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.564706 0 0 0 0 0.980392 0 0 0 0 0.992157 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12837_150142" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12837_150142" result="shape" />
        </filter>
        <filter
          id="filter1_d_12837_150142"
          x="73.28"
          y="73.28"
          width="53.44"
          height="53.44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="10" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_12837_150142" />
          <feOffset />
          <feGaussianBlur stdDeviation="4.86" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12837_150142" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12837_150142" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_12837_150142"
          x1="67.375"
          y1="111.265"
          x2="88.6189"
          y2="137.713"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C19C3" />
          <stop offset="1" stopColor="#3C19C3" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12837_150142"
          x1="128.375"
          y1="82.2654"
          x2="107.96"
          y2="61.2404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C19C3" />
          <stop offset="1" stopColor="#3C19C3" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_12837_150142"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(99.6386 100.248) rotate(100.441) scale(23.7162 22.4601)"
        >
          <stop stopColor="#90FAFD" />
          <stop offset="0.585" stopColor="#90FAFD" />
          <stop offset="1" stopColor="#58A8DF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_12837_150142"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(100 100) rotate(180) scale(8.86667)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.5" />
        </radialGradient>
      </defs>
    </svg>
  );
}
